import React from 'react';
// Mui components
import { Snackbar, Alert, Box, Typography } from '@mui/material';
//Icons
import iconCheck from '../../assets/icons/icon_check.svg';

export default function CustomSnackbar({ open, message, severity = 'info', onClose, icon }) {

  const shouldUseCustomIcon = severity === 'info' || severity === 'success';

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          borderRadius: '1rem'
        }
      }}>
      <Box
        sx={{
          minWidth: '374px !important',
          height: '52px !important'
        }}>
        <Alert
          icon={
            shouldUseCustomIcon ? (
              icon || (
                <Box
                  component="img"
                  sx={{ width: '15px', height: '15px' }}
                  alt="img not found"
                  src={iconCheck}
                />
              )
            ) : undefined
          }
          severity={severity}
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: severity === 'error'
              ? '#d32f2f'
              : severity === 'success'
                ? '#2e7d32'
                : severity === 'warning'
                  ? '#ed6c02'
                  : '#202327',
            color: 'white !important',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '1rem',
            '& .MuiAlert-message': {
              width: '100%'
            }
          }}
          onClose={null}>
          <Typography variant="bodyS">{message}</Typography>
        </Alert>
      </Box>
    </Snackbar>
  );
}
